"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("moment-field", className, styles.root),
        inputContainer: styling_1.mergeStyles("moment-field-input-container", styles.inputContainer),
        textField: styling_1.mergeStyles("moment-field-text-field", styles.textField),
        calendarButtonContainer: styling_1.mergeStyles("moment-field-calendar-container", styles.calendarButtonContainer),
        calendarButton: styling_1.mergeStyles("moment-field-calendar-button", styles.calendarButton)
    };
});
exports.getClassNames = getClassNames;
